import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import {
  fontSizes,
  fontWeight,
  lineHeights,
  space,
} from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';
import { container as scrollMoreContainer } from '@/components/scroll-to-explore/scroll-to-explore.css.ts';
import { welcomeContainer } from './page.css';

export const brandContainer = style(
  responsiveStyle({
    mobile: {
      marginTop: space.s20,
    },
    tablet: {},
    laptop: {
      marginTop: 0,
    },
  }),
);

export const content = style([
  {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  responsiveStyle({
    mobile: {
      justifyContent: 'end',
      marginBottom: space.s20,
      gap: space.s8,

      selectors: {
        [`${welcomeContainer}:has(${scrollMoreContainer}) &`]: {
          marginTop: 0,
        },
      },
    },
    tablet: {},
    laptop: {
      justifyContent: 'center',
      marginBottom: 0,
      gap: space.s48,

      selectors: {
        [`${welcomeContainer}:has(${scrollMoreContainer}) &`]: {
          marginTop: space.s64,
        },
      },
    },
  }),
]);

export const title = style([
  typography.headlineMd,
  {
    lineHeight: lineHeights.tight,
    color: themeVars.color.text.brand,
  },
  responsiveStyle({
    mobile: {
      textAlign: 'center',
    },
    tablet: {
      fontSize: fontSizes.displayLg,
    },
    laptop: {
      textAlign: 'left',
    },
    wide: {
      fontSize: '72px',
    },
  }),
]);

export const subTitle = style([
  title,
  responsiveStyle({
    mobile: {
      ...typography.bodyMd,
    },
    tablet: {
      ...typography.headlineSm,
      fontWeight: fontWeight.regular,
    },
    wide: {
      ...typography.headlineSm,
      fontWeight: fontWeight.regular,
    },
  }),
]);

export const mask = style({
  background: 'linear-gradient(285.33deg, #5333A6 16.87%, #BCAFDE 69.95%)',
  backgroundClip: 'text',
  color: 'transparent',
});
